(function () {
  'use strict';

  var LP = {
    data: window.__lpData || { pdpUrl: '/', prefix: 'lp_plaquinha_colo_', enableStickyCta: true },

    init: function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: this.data.prefix + 'view' });

      this.setupScrollDepth();
      this.setupRevealOnScroll();
      this.setupFaqAccordion();
      this.setupSlideshows();
      this.setupMiniReviewsDots();
      this.setupStickyCta();
      this.setupCtaTracking();
      this.setupExpertVideo();
    },

    setupMiniReviewsDots: function () {
      var mini = document.querySelector('.lp-mini-reviews');
      var dots = document.querySelectorAll('.lp-mini-reviews__dots .lp-dot');
      if (!mini || !dots.length) return;

      function cardStep() {
        var cards = mini.querySelectorAll('.lp-mini-review');
        if (!cards.length) return 0;
        return cards[0].offsetWidth + 12;
      }

      function getActiveIndex() {
        var step = cardStep();
        if (step <= 0) return 0;
        return Math.round(mini.scrollLeft / step);
      }

      function updateDots() {
        var idx = getActiveIndex();
        if (idx < 0) idx = 0;
        if (idx > dots.length - 1) idx = dots.length - 1;
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
          d.setAttribute('aria-current', i === idx ? 'true' : 'false');
        });
      }

      function goTo(i) {
        var step = cardStep();
        if (step <= 0) return;
        mini.scrollTo({ left: step * i, behavior: 'smooth' });
      }

      mini.addEventListener('scroll', updateDots, { passive: true });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { goTo(i); });
      });

      updateDots();
    },

    setupScrollDepth: function () {
      var self = this;
      var fired = {};
      function onScroll() {
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (docHeight <= 0) return;
        var pct = Math.round((window.scrollY / docHeight) * 100);
        [25, 50, 75, 100].forEach(function (d) {
          if (!fired[d] && pct >= d) {
            fired[d] = true;
            window.dataLayer.push({ event: self.data.prefix + 'scroll_depth', percent: d });
          }
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    },

    setupRevealOnScroll: function () {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

      document.querySelectorAll('.lp-block').forEach(function (block) {
        block.classList.add('lp-reveal');
        observer.observe(block);
      });

      var staggerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            staggerObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

      document.querySelectorAll('.lp-stagger').forEach(function (el) {
        staggerObserver.observe(el);
      });
    },

    setupFaqAccordion: function () {
      var self = this;
      document.querySelectorAll('.lp-faq__item').forEach(function (item) {
        var btn = item.querySelector('.lp-faq__question');
        var answer = item.querySelector('.lp-faq__answer');
        if (!btn || !answer) return;

        btn.setAttribute('aria-expanded', 'false');

        function toggle() {
          var isOpen = item.classList.contains('is-open');
          document.querySelectorAll('.lp-faq__item.is-open').forEach(function (openItem) {
            openItem.classList.remove('is-open');
            var ob = openItem.querySelector('.lp-faq__question');
            var oa = openItem.querySelector('.lp-faq__answer');
            if (ob) ob.setAttribute('aria-expanded', 'false');
            if (oa) oa.style.maxHeight = '0';
          });
          if (!isOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            answer.style.maxHeight = answer.scrollHeight + 'px';
            var qtext = btn.querySelector('.lp-faq__question-text');
            window.dataLayer.push({
              event: self.data.prefix + 'faq_expand',
              question: qtext ? qtext.textContent.trim() : btn.textContent.trim()
            });
          }
        }

        btn.addEventListener('click', toggle);
        btn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
        });
      });
    },

    setupSlideshows: function () {
      document.querySelectorAll('.lp-slideshow').forEach(function (sh) {
        var track = sh.querySelector('.lp-slideshow__track');
        var slides = sh.querySelectorAll('.lp-slide');
        var dots = sh.querySelectorAll('.lp-dot');
        var prev = sh.querySelector('.lp-slideshow__prev');
        var next = sh.querySelector('.lp-slideshow__next');
        if (!track || !slides.length) return;

        function currentIndex() {
          if (!slides[0]) return 0;
          var w = slides[0].offsetWidth;
          if (w === 0) return 0;
          return Math.round(track.scrollLeft / w);
        }

        function update() {
          var idx = currentIndex();
          dots.forEach(function (d, i) {
            d.classList.toggle('is-active', i === idx);
            d.setAttribute('aria-current', i === idx ? 'true' : 'false');
          });
          if (prev) prev.disabled = idx <= 0;
          if (next) next.disabled = idx >= slides.length - 1;
        }

        function goTo(i) {
          if (!slides[0]) return;
          var w = slides[0].offsetWidth;
          track.scrollTo({ left: w * i, behavior: 'smooth' });
        }

        track.addEventListener('scroll', update, { passive: true });

        dots.forEach(function (d, i) {
          d.addEventListener('click', function () { goTo(i); });
        });

        if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, currentIndex() - 1)); });
        if (next) next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, currentIndex() + 1)); });

        sh.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, currentIndex() - 1)); }
          if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(slides.length - 1, currentIndex() + 1)); }
        });

        update();
      });
    },

    setupStickyCta: function () {
      var self = this;
      var sticky = document.querySelector('.lp-sticky-cta');
      if (!sticky) return;
      if (!self.data.enableStickyCta) return;

      var threshold = window.innerHeight * 0.8;
      var stickyShown = false;

      function onScroll() {
        var scrolled = window.scrollY > threshold;
        sticky.classList.toggle('is-visible', scrolled);
        if (scrolled && !stickyShown) {
          stickyShown = true;
          window.dataLayer.push({ event: self.data.prefix + 'sticky_shown' });
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });

      if ('IntersectionObserver' in window) {
        var finalCta = document.querySelector('.lp-final-cta');
        if (finalCta) {
          var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              sticky.classList.toggle('is-hidden-by-final', entry.isIntersecting);
            });
          }, { threshold: 0.15 });
          observer.observe(finalCta);
        }
      }
    },

    setupCtaTracking: function () {
      var self = this;
      var pdpUrl = self.data.pdpUrl;
      var position = 0;
      document.querySelectorAll('.lp-cta').forEach(function (cta) {
        position++;
        var blockEl = cta.closest('[data-block-type]');
        var blockType = blockEl ? blockEl.dataset.blockType : 'unknown';
        var pos = position;
        cta.addEventListener('click', function (e) {
          e.preventDefault();
          window.dataLayer.push({
            event: self.data.prefix + 'cta_click',
            block: blockType,
            position: pos
          });
          setTimeout(function () { window.location.href = pdpUrl; }, 160);
        });
      });
    },

    setupExpertVideo: function () {
      var self = this;
      document.querySelectorAll('.lp-expert-video__player[data-lp-yt]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-lp-yt');
          if (!id) return;
          var media = btn.parentNode;
          var iframe = document.createElement('iframe');
          iframe.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1');
          iframe.setAttribute('title', btn.getAttribute('aria-label') || 'YouTube video');
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
          iframe.setAttribute('allowfullscreen', '');
          media.replaceChild(iframe, btn);
          window.dataLayer.push({ event: self.data.prefix + 'video_play', video_id: id });
        }, { once: true });
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { LP.init(); });
  } else {
    LP.init();
  }
})();
